import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { SnackbarProps, SnackbarType } from './types';
import useSnackbar from './useSnackbar';
import styles from './Snackbar.module.css';

/**
 * 通知メッセージを表示するスナックバーコンポーネント
 */
const Snackbar: React.FC<SnackbarProps> = ({ 
  message, 
  open, 
  type = SnackbarType.DEFAULT, 
  onClose, 
  closeButtonDuration = 3000 
}) => {
  const { shouldRender, showCloseButton } = useSnackbar({
    open,
    closeButtonDuration
  });
  
  if (!shouldRender) return null;

  // CSSモジュールでクラス名を取得
  const baseClass = styles.snackbar;
  const typeClass = styles[`snackbar__${type}`] || '';
  const stateClass = open ? styles.snackbar__open : styles.snackbar__close;

  return (
    <div 
      className={`${baseClass} ${typeClass} ${stateClass}`}
      data-testid="snackbar"
    >
      <div className={styles.snackbar__message} data-testid="snackbar__message">
        {message}
      </div>
      {showCloseButton && (
        <button 
          className={styles.snackbar__close_btn} 
          onClick={onClose}
          data-testid="snackbar__close-btn"
        >
          <FaTimes />
        </button>
      )}
    </div>
  );
};

export default Snackbar; 